import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const ScheduleFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Schedule Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the ScheduleFrame component. Replace this with your actual UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default ScheduleFrame;
